'use strict';

import 'nls!./number_of_people.json';

const translationKeyPrefix = 'NUMBER_OF_PEOPLE.';

export default [
  {
    value: 1,
    translationKey: translationKeyPrefix + '1'
  },
  {
    value: 2,
    translationKey: translationKeyPrefix + '2'
  },
  {
    value: 3,
    translationKey: translationKeyPrefix + '3'
  },
  {
    value: 4,
    translationKey: translationKeyPrefix + '4'
  }
];



// WEBPACK FOOTER //
// ./app/src/constants/number_of_people.js